export function getLokaliseKeyByProduct(product, identifier) {
  const IT_KEYS = {
    organisationHeading: 'itsm.organisation.heading',
    orgSubInformation: 'itsm.organisation.subheading',
    platFormPreferences: 'itsm.organisation.platform.preferences',
    orgSignature: 'itsm.organisation.signature',
    domainEmailSubHeading: 'itsm.domain.email.subheading',
    supportChannelsSubHeading: 'admin.supportChannels.header.label',
    addSupportMailBoxHeading: 'itsm.support.mailbox.add',
    addSupportMailBoxDesc: 'itsm.support.mailbox.description',
    organisationName: 'itsm.organisation.name',
    mailboxTechGroupBanner: 'itsm.add.mailbox.techgroup.banner',
    slaSubHeading: 'itsm.sla.subheading',
    notificationCenterSubHeading: 'itsm.notification.center.description',
    requesterRolesSubHeading: 'itsm.requester.role.description',
    techGroupSubHeading: 'itsm.technician.group.description',
    manageFieldsDescription: 'itsm.manage.fields.description',
    requesterNotificationHeading: 'common.user.notifications',
    techGroupClientBoxHeading: 'common.sites',
    techGroupChooseClientSite: 'common.choose.sites',
    techGroupSelectedClientSite: 'common.selected.sites',
    techGroupAllClientSite: 'client.contract.invoiceItems.allSites',
    techGroupAvailableClientSite: 'client.contract.invoiceItems.allSites',
    techGroupAllSelectionBanner: 'itsm.techgroup.all.sites.banner',
    techGroupIndividual: 'itsm.techgroup.individual.sites',
    teamViewerDescription: 'itsm.marketplace.teamviewer.description',
    connectWiseDescription: 'itsm.marketplace.connectwise.description',
    connectWiseInstructions: 'itsm.marketplace.connectwise.instructions',
    splashtopDesription: 'itsm.marketplace.splashtop.description',
    splashtopOldPlanDesription: 'itsm.marketplace.splashtop.description',
    azureDescription: 'itsm.marketplace.azure.description',
    azureTokenTitle: 'itsm.marketplace.azure.token.title',
    azureInstructions: 'itsm.marketplace.azure.instructions',
    azureGenerateTooltip: 'itsm.integrations.generate.token.tooltip',
    oktaInstructions: [
      'itsm.integrations.okta.instructions.step1',
      'itsm.integrations.okta.instructions.step2',
      'itsm.integrations.okta.instructions.step3'
    ],
    associateUnknownTicket: 'itsm.ticket.unknown.associate.to.requester',
    chooseTechnicianPlaceholder: 'client.details.user.chooseUser',
    deleteEmployeeTitle: 'itsm.admin.employee.delete.modal.title',
    deleteEmployeeDescription: 'itsm.admin.employee.delete.modal.desc',
    forgotEmployeeTitle: 'itsm.admin.employee.forget.modal.title',
    forgotEmployeeDescription: 'itsm.admin.employee.forget.modal.desc',
    techLoginHeading: 'itsm.user.login',
    techLoginSubHeading: 'itsm.user.login.description',
    userPasswordPolicy: 'itsm.user.password.policy',
    userTfaEnforce: 'itsm.user.enforce.tfa',
    userTfaHelpText: 'itsm.user.tfa.helptext',
    techGroupClientsEmpty: 'itsm.sites.empty',
    migrateDataDescription: 'itsm.migrate.data.page.subtitle',
    onboardingAgentDeploy: 'itsm.onboarding.agent.section.description',
    eventTriggerDesc: 'itsm.event.trigger.description',
    assetClassDesc: 'itsm.assetClass.header.label',
    remoteConnectDesc: 'itsm.remote.connect.description',
    contributePrompts: 'itsm.ai.page.prompt.contribute',
    replyContainerDesc: 'itsm.template.header.description',
    itShareEmtpy: 'itsm.itdoc.share.emtpy.desc',
    satisfactionSurvey: 'itsm.satisfaction.survey',
    manageSurvey: 'itsm.manage.satisfaction.survey',
    policyManagementDesc: 'common.policy.management.description',
    marketplaceDesc: 'itsm.marketplace.description',
    systemTrayDesc: 'itsm.system.tray.description',
    systemTrayConfig: 'itsm.system.tray.config',
    advancePolicyDesc: 'itsm.advance.policy.onboard.description',
    ISLDesc: 'integration.isl.desc',
    shareITDoc: 'itsm.share.doc.remove.description',
    reshareITDocHeading: 'itsm.share.IT.doc.client.change.heading',
    reshareITDocDesc: 'itsm.share.IT.doc.client.change.description',
    assetBulkClientSite: 'common.change.site',
    oktaDescription: 'admin.integrations.okta.description',
    esetDescription: 'admin.integration.esetit.description',
    slaHqHours: 'itsm.sla.hq.hours',
    slaClientHours: 'itsm.sla.site.hours'
  };
  const MSP_KEYS = {
    slaHqHours: 'admin.slaMetric.slaCalculation.mspBusinessHours',
    slaClientHours: 'admin.slaMetric.slaCalculation.clientBusinessHours',
    advancePolicyDesc: 'policyMgmt.onboardScreen.effortlessOrganization.desc',
    systemTrayConfig: 'agent.branding.card.message',
    systemTrayDesc: 'admin.agent.rebranding.desc',
    marketplaceDesc: 'admin.integrations.description',
    policyManagementDesc: 'admin.policyManagement.hierarchyPolicySet.helpText',
    manageSurvey: 'admin.customerSatisfaction.header.label',
    satisfactionSurvey: 'admin.customerSatisfaction.header',
    itShareEmtpy: 'rmm.itdocument.no.clients.description',
    replyContainerDesc: 'admin.template.header.description',
    contributePrompts: 'settings.ai.page.prompt.contribute',
    organisationHeading: 'admin.mspDetails.header',
    orgSubInformation: 'admin.mspDetails.header.label',
    platFormPreferences: 'admin.mspDetails.mspinfo.title',
    orgSignature: 'admin.mspSettings.mspSignature',
    domainEmailSubHeading: 'admin.EmailServerSettings.header.label',
    addSupportMailBoxHeading: 'admin.mailbox.configureMultipleMailbox.header',
    addSupportMailBoxDesc: 'admin.mailbox.configureMultipleMailbox.description',
    organisationName: 'admin.EmailServerSettings.response.msp',
    mailboxTechGroupBanner: 'admin.mailbox.advancedSettings.banner',
    slaSubHeading: 'admin.slaPolicy.header.label',
    notificationCenterSubHeading: 'settings.notificationCenter.description',
    requesterRolesSubHeading: 'admin.Requesterrole.header.label',
    techGroupSubHeading: 'admin.Techniciangroup.header.label',
    manageFieldsDescription: 'admin.CustomFieldsSettings.header.subtitle',
    requesterNotificationHeading:
      'settings.notificationCenter.requesterNotifications',
    techGroupClientBoxHeading: 'admin.Techniciangroup.Clients',
    techGroupChooseClientSite: 'admin.Techniciangroup.associateclients.list',
    techGroupSelectedClientSite: 'admin.Techniciangroup.selectedclients.list',
    techGroupAllClientSite: 'client.listView.allClients',
    techGroupAvailableClientSite: 'client.listView.allClients',
    techGroupAllSelectionBanner:
      'admin.Techniciangroup.clientPreference.allClients.banner.info',
    techGroupIndividual: 'admin.Techniciangroup.clientPreference.clients',
    teamViewerDescription: 'admin.integrations.teamviewer.description',
    connectWiseDescription: 'admin.integrations.connectwise.description',
    connectWiseInstructions:
      'admin.integrations.connectwise.instructions.detail',
    splashtopDesription: 'admin.integrations.super.splashtop.description',
    splashtopOldPlanDesription: 'admin.integrations.splashtop.description',
    azureDescription: 'admin.integrations.azure.description',
    azureTokenTitle: 'admin.integrations.azure.mspTokenAndUrl',
    azureInstructions: 'admin.integrations.azure.instructions',
    azureGenerateTooltip: 'admin.integrations.generate.token.tooltip',
    associateUnknownTicket: 'ticket.unknown.associate.to.client',
    chooseTechnicianPlaceholder: 'admin.slaPolicy.performActions.choosetech',
    deleteEmployeeTitle: 'admin.employee.delete.modal.title',
    deleteEmployeeDescription: 'admin.employee.delete.modal.desc',
    forgotEmployeeTitle: 'admin.employee.forget.modal.title',
    forgotEmployeeDescription: 'admin.employee.forget.modal.desc',
    techLoginHeading: 'admin.technicianLogin.header',
    techLoginSubHeading: 'admin.technicianLogin.header.label',
    userPasswordPolicy: 'admin.technicianLogin.pwdPolicy.title',
    technicianPasswordPolicy: 'admin.technicianLogin.pwdPolicy.title',
    requesterPasswordPolicy: 'admin.requesterLogin.pwdPolicy.title',
    userTfaEnforce: 'admin.technicianLogin.tfa.enforce',
    userTfaHelpText: 'admin.technicianLogin.tfa.helptext',
    techGroupClientsEmpty: 'admin.technicianGroup.clients.empty',
    migrateDataDescription: 'migrate.data.page.subtitle',
    onboardingAgentDeploy: 'onboarding.agent.section-des',
    eventTriggerDesc: 'admin.eventTriggers.header.label',
    assetClassDesc: 'admin.assetClass.header.label',
    remoteConnectDesc: 'admin.integrations.connectRemote.description',
    ISLDesc: 'integration.isl.desc',
    shareITDoc: 'rmm.share.IT.doc.remove.description',
    reshareITDocHeading: 'rmm.share.IT.doc.client.change.heading',
    reshareITDocDesc: 'rmm.share.IT.doc.client.change.description',
    assetBulkClientSite: 'asset.management.bulk.select.client',
    esetDescription: 'admin.integration.eset.description',
    oktaInstructions: [
      'itsm.integrations.okta.instructions.step1',
      'itsm.integrations.okta.instructions.step2',
      'itsm.integrations.okta.instructions.step3'
    ],
    oktaDescription: 'admin.integrations.msp.okta.description'
  };

  const lokalise = {
    IT: { ...IT_KEYS },
    MSP: { ...MSP_KEYS }
  };
  return lokalise[product][identifier] || 'NA';
}
